import axios from 'axios'
import get from 'lodash/get'

// Libs
import { thunkHandler, thunkErrorHanlder, parseUrl } from '../../libs/utils'

// Constants
import { GET_TAXES, CREATE_PRODUCT, EDIT_PRODUCT,  ADD_TAX, DELETE_TAX } from '../../constants/endpoints'

export const NEW_TAXES             = 'NEW_TAXES'
export const NEW_PRODUCT           = 'NEW_PRODUCT'
export const NEW_TAX               = 'NEW_TAX'
export const NEW_TABLE_PRODUCTS    = 'NEW_TABLE_PRODUCTS'

export function getTaxes(data) {
    const itemPrice = get(data, "price", 0);
    return dispatch => axios.get(parseUrl(GET_TAXES, { itemPrice }))
        .then(res => thunkHandler(dispatch, get(res, 'data.data'), NEW_TAXES, 'ERROR'))
        .catch(error => thunkErrorHanlder(error, dispatch, 'ERROR'));
} // END getTaxes

export function createProduct(data) {
    return dispatch => axios.post(parseUrl(CREATE_PRODUCT), data)
        .then(res => thunkHandler(dispatch, get(res, 'data.data'), NEW_PRODUCT, 'ERROR'))
        .catch(error => thunkErrorHanlder(error, dispatch, 'ERROR'));
} // END createProduct

export function editProduct(product, body) {
  const uuid = get(product, 'uuid')
  return dispatch => axios.put(parseUrl(EDIT_PRODUCT, { uuid }), body)
      .catch(error => thunkErrorHanlder(error, dispatch, 'ERROR'));
} // END editProduct

export function addTax(uuid, body ){
  return dispatch => Promise.all(body.map(tax => axios.post(parseUrl(ADD_TAX, { uuid }), tax)))
      .catch(error => thunkErrorHanlder(error, dispatch, 'ERROR'));
} // END addTax

export function deleteTax(uuid, body ){
  return dispatch => Promise.all(body.map(tax => {
      const {id } = tax
      return axios.delete(parseUrl(DELETE_TAX, { uuid, id }))
      }))
      .catch(error => thunkErrorHanlder(error, dispatch, 'ERROR'));
} // END deleteTax

export function getTableProducts(products) {
  const
    addenda = products.filter(product => !!product.adenda),
    emptyAddenda = addenda.filter(product => (product.attributes.cfdi_curp === ""));

  return dispatch => Promise.resolve(dispatch({
    type: NEW_TABLE_PRODUCTS,
    payload:{tableProducts: products, addendaProducts: addenda, emptyAddenda: emptyAddenda}
  }));
} // END tableProducts

export function getProduct(uuid) {
  return dispatch => axios.get(parseUrl(EDIT_PRODUCT, { uuid }))
      .then(res => thunkHandler(dispatch, get(res, 'data.data'), NEW_PRODUCT, 'ERROR'))
      .catch(error => thunkErrorHanlder(error, dispatch, 'ERROR'));

} // END createProduct



// WEBPACK FOOTER //
// ./src/redux/actions/productsActions.js